module.exports = __webpack_public_path__ + "static/img/index-tab3-bottom.402afb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-tab3-bottom.png
// module id = NLR1
// module chunks = 1